import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';
import { CompetitionFileRequest } from '~/apis/ssf';

export function useUploadCompetitionFileMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (data: CompetitionFileRequest) => {
      return await SSF.api.competitionFilesCreate(data, {
        type: 'multipart/form-data',
      });
    },
    retry: false,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useDeleteCompetitionFileMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.competitionFilesDestroy>[0]) =>
      SSF.api.competitionFilesDestroy(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}
